import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AnchorMixin } from '../../mixins/components/AnchorMixin';
import CustomPropTypes from '../../util/custom-prop-types';
/**
 * A basic [HTML anchor element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a).
 * Anchors are links found inline within a body of text, inheriting the font attributes
 * (i.e. font-size, font-weight, etc).
 * For stand-alone links, you should use the [`TextButton`](#/Button%20components?id=textbutton)
 * component.
 *
 * Anchors should be used for navigation only -- navigation between pages, or to different "anchor"
 * points within the same page. For other actions that are not navigation, a button should be used.
 * If a regular [`Button`](#/Button%20components?id=button) or
 * [`TextButton`](#/Button%20components?id=textbutton) do not suffice and you need to use
 * anchor styling, make sure to set `as="button"` to help assistive technologies better represent
 * the purpose of the component.
 *
 * Note that some [spacing](#/%40zillow%2Fconstellation/Tokens?id=section-spacing) props will
 * not work since anchors are inline. For more information and workarounds, see the documentation
 * for [spacing](#/%40zillow%2Fconstellation/Tokens?id=section-spacing).
 *
 * @since 6.0.0
 */

var Anchor = /*#__PURE__*/styled.a.withConfig({
  displayName: "Anchor",
  componentId: "c11n-8-81-1__sc-hn4bge-0"
})(["", ""], AnchorMixin);
Anchor.propTypes = {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   *
   * By default, this is a basic `<a>` element, but if you are using this component for an action
   * other than navigation, you should set this to `as="button"`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any,

  /**
   * For use on dark or colored backgrounds.
   */
  inverse: CustomPropTypes.inlineMediaQuery(PropTypes.bool)
};
Anchor.defaultProps = {
  as: 'a',
  inverse: false
};
/** @component */

export default Anchor;
export var StyledAnchor = Anchor;